import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";

import diseases from "./diseases.module";
import studies from "./studies.module";
import groups from "./groups.module";
import users from "./users.module";
import patients from "./patients.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,

    diseases,
    studies,
    groups,
    users,
    patients,
  },
});
